import { ScreenIds } from '~/types/screenIds'
import { isTransitionFromCoordinate } from './isTransitionFromCoordinate'
import { KIds } from './kIds'

// GA、アフィリエイト用のkidを取得する関数

/**
 * アイテム ZOZOTOWNで在庫を見るボタンなど用
 * @param screenId 前回の画面のid
 * @param coordinateId コーディネイトのid。coordinate.id
 */
export const getItemKidForPurchaseItem = (
  screenId: ScreenIds | undefined,
  coordinateId = 0
): string => {
  if (isTransitionFromCoordinate(screenId ?? ScreenIds.SP, coordinateId))
    return (KIds.BuyByCoordinate + coordinateId).toString()
  return KIds.BuyByItem.toString()
}

/**
 * アイテム ZOZOTOWNで同じアイテムを探すボタンなど用
 * @param screenId 前回の画面のid
 * @param coordinateId コーディネイトのid。coordinate.id
 */
export const getItemKidForSearch = (
  screenId: ScreenIds | undefined,
  coordinateId = 0
): string => {
  if (isTransitionFromCoordinate(screenId ?? ScreenIds.SP, coordinateId))
    return (KIds.SearchByCoordinate + coordinateId).toString()
  return KIds.SearchByItem.toString()
}

/**
 * 着用アイテム ZOZOTOWNで同じアイテムを探すボタンなど用
 * @param screenId 前回の画面のid
 * @param coordinateId コーディネイトのid。coordinate.id
 */
export const getCoordinateItemKidForSearch = (
  screenId: ScreenIds | undefined,
  coordinateId = 0
): string => {
  if (isTransitionFromCoordinate(screenId ?? ScreenIds.SP, coordinateId))
    return (KIds.SearchByCoordinate + coordinateId).toString()
  return KIds.SearchByCoordinateItem.toString()
}

// その他個別のボタン用
export const otherKid = {
  TOP_DRAWER_INFOTXT: '399999969',
  SEARCH_SNAP_HGBL: '399999952',
  SEARCH_SNAP_FTR: '399999981',
  SNAP_DETAIL_HGBL: '399999951',
  SEARCH_ITEM_HGBL: '399999950',
  ITEM_DETAIL_HGBL: '399999949',
  SEARCH_USER_HGBL: '399999948',
  OTHER_HGBL: '399999947',
  TOP_HGBL: '399999934',
  TOP_FBNR: '399999999',
  TOP_DRAWER_BNR: '399999998',
  SNAP_DETAIL_FBNR: '399999996',
  LP: '61000-69999',
  SPMSG: '399999938',
  WEAR_TOP_FSUMMARY: '399999989',
  TOP_DRAWER_EMBNR: '399999933',
  INFO_MAIN_AD: '399999936',
  INFO_SUB_AD: '399999935',
} as const
